/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// Import React so that you can use JSX in this file
const React = require("react");
const { navigate } = require("gatsby");
const Layout = require("./src/components/layout").default;
require("./src/styles/global.css");
const { AuthProvider } = require("./src/context/AuthContext");

// Global store for WordPress redirects map
// This will be populated from the page context during onRouteUpdate
let wordpressRedirectsMap = null;

// Track if we've already executed a redirect for the current URL
// to prevent infinite redirect loops
let hasExecutedRedirect = false;

/**
 * Called when the route changes
 */
exports.onRouteUpdate = ({ location, prevLocation }, { wordpressRedirects }) => {
  // Store the redirects map if provided (from the root page)
  if (wordpressRedirects && Object.keys(wordpressRedirects).length > 0) {
    console.log(`[gatsby-browser] Storing ${Object.keys(wordpressRedirects).length} WordPress redirects`);
    wordpressRedirectsMap = wordpressRedirects;
  }
  
  // Reset the redirect flag on route change
  hasExecutedRedirect = false;
  
  // Handle WordPress redirects
  handleWordPressRedirect(location);
};

/**
 * Called when the initial route is loaded
 */
exports.onInitialClientRender = () => {
  // Handle WordPress redirects on initial render
  if (typeof window !== 'undefined') {
    handleWordPressRedirect(window.location);
  }
};

/**
 * Function to handle WordPress-style redirects
 */
const handleWordPressRedirect = (location) => {
  // Prevent executing if we don't have redirects or already executed
  if (!wordpressRedirectsMap || hasExecutedRedirect || !location) {
    return;
  }
  
  // Only perform redirect if we have a ?p= parameter
  if (!location.search || !location.search.includes('p=')) {
    return;
  }
  
  console.log('[gatsby-browser] Checking WordPress redirect for:', location.search);
  
  // Parse the query parameters
  const params = new URLSearchParams(location.search);
  const postId = params.get('p');
  
  // Clean up the post ID - remove any trailing slash
  const cleanPostId = postId ? postId.replace(/\/$/, '') : null;
  
  console.log(`[gatsby-browser] WordPress Redirect: Looking for post ID "${cleanPostId}"`);
  
  // If we have a post ID and it matches one of our redirects, set up the redirect
  if (cleanPostId && wordpressRedirectsMap[cleanPostId]) {
    const destination = wordpressRedirectsMap[cleanPostId];
    console.log(`[gatsby-browser] WordPress Redirect: FOUND MATCH for post ID ${cleanPostId} -> ${destination}`);
    
    // Set the flag to prevent infinite loops
    hasExecutedRedirect = true;
    
    // Execute the redirect
    console.log(`[gatsby-browser] WordPress Redirect: Navigating to ${destination}`);
    navigate(destination, { replace: true });
  } else {
    console.log(`[gatsby-browser] WordPress Redirect: NO MATCH FOUND for post ID "${cleanPostId}"`);
  }
};

// Log environment variables for debugging
if (typeof window !== 'undefined') {
  console.log('Gatsby Environment Variables Check:', {
    NODE_ENV: process.env.NODE_ENV,
    HAS_LISTMONK_URL: Boolean(process.env.GATSBY_LISTMONK_URL),
    HAS_LISTMONK_USERNAME: Boolean(process.env.GATSBY_LISTMONK_USERNAME),
    HAS_LISTMONK_PASSWORD: Boolean(process.env.GATSBY_LISTMONK_PASSWORD),
    HAS_LISTMONK_WELCOME_LIST_ID: Boolean(process.env.GATSBY_LISTMONK_WELCOME_LIST_ID),
    HAS_LISTMONK_WELCOME_TEMPLATE_ID: Boolean(process.env.GATSBY_LISTMONK_WELCOME_TEMPLATE_ID)
  });
  
  // Ensure Plotly is loaded in the browser
  if (!window.Plotly) {
    const script = document.createElement('script');
    script.src = 'https://cdn.plot.ly/plotly-2.24.1.min.js';
    script.async = true;
    document.head.appendChild(script);
    console.log('Plotly script dynamically added to head');
  }
}

// Wrap the root element with the AuthProvider
exports.wrapRootElement = ({ element }) => (
  React.createElement(AuthProvider, null, element)
);

// Wraps each page with the Layout component
exports.wrapPageElement = ({ element, props }) => {
  return React.createElement(Layout, props, element);
};
